// Barre d'avancement du cycle de vente.
// `stage` = index de l'étape courante (0 Devis … 4 Payée) ; stage=5 = tout terminé.
// `compact` : version dense (pastilles seules, sans libellés) pour les lignes de liste.

const STEPS = ['Devis', 'Commande', 'Livrée', 'Facturée', 'Payée'];

export default function Stepper({ stage, compact = false }: { stage: number; compact?: boolean }) {
  return (
    <ol className={`stepper${compact ? ' compact' : ''}`} aria-label="Avancement de la vente">
      {STEPS.map((label, i) => {
        const cls = i < stage ? 'done' : i === stage ? 'current' : 'todo';
        return (
          <li key={label} className={`step ${cls}`} title={compact ? label : undefined}>
            <span className="step-dot">{i < stage ? '✓' : i + 1}</span>
            {!compact && <span className="step-label">{label}</span>}
          </li>
        );
      })}
    </ol>
  );
}
